var loop = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/paint-ww/loop.jpg';
var loopDetail1 = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/paint-ww/loopDetail1.jpg';
var echo = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/paint-ww/echo.jpg';
var echoDetail1 = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/paint-ww/echoDetail1.jpg';
var ellipse = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/paint-ww/ellipse_v3.jpg';
var crawl = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/paint-ww/crawl.jpg';
var lasso = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/paint-ww/lasso.jpg';
var lassoDetail1 = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/paint-ww/lassoDetail1.jpg';
var wings = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/paint-ww/wings.jpg';
var wingsDetail1 = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/paint-ww/wingsDetail1.jpg';

export const allImagesDesktopOrderWw = [
    [/*COLUMN 1*/
        [
            {
                name: loop,
                artistName: "Lorraine Shemesh",
                title: "Loop",
                year: "1999",
                dimensions: "51 1/2 x 79 in., o/c",
                link: "ww1",
                privateCollection: "Private Collection"
            },
            {
                name: loopDetail1,
                artistName: "Lorraine Shemesh",
                title: "Loop - detail",
                year: "1999",
                dimensions: "51 1/2 x 79 in., o/c",
                link: "ww2",
                privateCollection: "Private Collection"
            }
        ],
        [
            {
                name: echo,
                artistName: "Lorraine Shemesh",
                title: "Echo",
                year: "2005",
                dimensions: "64 x 66 in., o/c",
                link: "ww3",
                privateCollection: "Private Collection"
            },
            {
                name: echoDetail1,
                artistName: "Lorraine Shemesh",
                title: "Echo - detail",
                year: "2005",
                dimensions: "64 x 66 in., o/c",
                link: "ww4",
                privateCollection: "Private Collection"
            }
        ],
        [
            {
                name: crawl,
                artistName: "Lorraine Shemesh",
                title: "Crawl",
                year: "1998",
                dimensions: "77 x 52 1/4 in., o/c",
                link: "ww6",
                privateCollection: "Private Collection"
            }
        ]
    ],
    [/*COLUMN 2*/
        [
            {    
                name: ellipse,
                artistName: "Lorraine Shemesh",
                title: "Ellipse",
                year: "1998",
                dimensions: "78 x 43 3/4 in., o/c",
                link: "ww5",
                privateCollection: "Private Collection"
            }
        ],
        [
            {
                name: wings,
                artistName: "Lorraine Shemesh",
                title: "Wings",
                year: "2008",
                dimensions: "64 1/4 x 63 1/4 in., o/c",
                link: "ww9",
                privateCollection: "Private Collection"
            },
            {
                name: wingsDetail1,
                artistName: "Lorraine Shemesh",
                title: "Wings - detail",
                year: "2008",
                dimensions: "64 1/4 x 63 1/4 in., o/c",
                link: "ww10",
                privateCollection: "Private Collection"
            }
        ]
    ],
    [/*COLUMN 3*/
        [
            {
                name: lasso,
                artistName: "Lorraine Shemesh",
                title: "Lasso",
                year: "2000",
                dimensions: "78 3/4 x 52 1/2 in., o/c",
                link: "ww7",
                privateCollection: "Private Collection"
            },
            {
                name: lassoDetail1,
                artistName: "Lorraine Shemesh",
                title: "Lasso- detail",
                year: "2000",
                dimensions: "78 3/4 x 52 1/2 in., o/c",
                link: "ww8",
                privateCollection: "Private Collection"
            }
        ]
    ]          
]

export const allImagesMobileOrderWw = [
    [{
        name: loop,
        artistName: "Lorraine Shemesh",
        title: "Loop",
        year: "1999",
        dimensions: "51 1/2 x 79 in., o/c",
        link: "ww1",
        privateCollection: "Private Collection"
    },
    {
        name: loopDetail1,
        artistName: "Lorraine Shemesh",
        title: "Loop - detail",
        year: "1999",
        dimensions: "51 1/2 x 79 in., o/c",
        link: "ww2",
        privateCollection: "Private Collection"
    },
    {
        name: echo,
        artistName: "Lorraine Shemesh",
        title: "Echo",
        year: "2005",
        dimensions: "64 x 66 in., o/c",
        link: "ww3",
        privateCollection: "Private Collection"
    },
    {
        name: echoDetail1,
        artistName: "Lorraine Shemesh",
        title: "Echo - detail",
        year: "2005",
        dimensions: "64 x 66 in., o/c",
        link: "ww4",
        privateCollection: "Private Collection"
    },
    {    
        name: ellipse,
        artistName: "Lorraine Shemesh",
        title: "Ellipse",
        year: "1998",
        dimensions: "78 x 43 3/4 in., o/c",
        link: "ww5",
        privateCollection: "Private Collection"
    },
    {
        name: crawl,
        artistName: "Lorraine Shemesh",
        title: "Crawl",
        year: "1998",
        dimensions: "77 x 52 1/4 in., o/c",
        link: "ww6",
        privateCollection: "Private Collection"
    },
    {
        name: lasso,
        artistName: "Lorraine Shemesh",
        title: "Lasso",
        year: "2000",
        dimensions: "78 3/4 x 52 1/2 in., o/c",
        link: "ww7",
        privateCollection: "Private Collection"
    },
    {
        name: lassoDetail1,
        artistName: "Lorraine Shemesh",
        title: "Lasso- detail",
        year: "2000",
        dimensions: "78 3/4 x 52 1/2 in., o/c",
        link: "ww8",
        privateCollection: "Private Collection"
    },
    {
        name: wings,
        artistName: "Lorraine Shemesh",
        title: "Wings",
        year: "2008",
        dimensions: "64 1/4 x 63 1/4 in., o/c",
        link: "ww9",
        privateCollection: "Private Collection"
    },
    {
        name: wingsDetail1,
        artistName: "Lorraine Shemesh",
        title: "Wings - detail",
        year: "2008",
        dimensions: "64 1/4 x 63 1/4 in., o/c",
        link: "ww10",
        privateCollection: "Private Collection"
    }]      
]
